<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 教程 -->
    <div class="main-wrapper-content course">
      <div class="courseList-filt">
        <h3 class="part-title">
          资源分类
        </h3>
        <div class="filt-list curriculum">
          <el-tabs v-model="categoryActive" type="border-card" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in category" :key="index" :label="item.name" :name="item.id">
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="course-list">
      <h3 class="part-title">
        资源列表
      </h3>
      <div class="card-box">
        <!-- 最热 最火 最高 -->
        <div class="card-li" v-for="(item, i) in  listData" :key="i" @click="toDetails(item.id)">
          <div class="home-course-list">
            <div class="home-course-item">
              <img :src="item.thumb" />
            </div>
            <div class="home-course-des">
              <div class="authers">
                <span>
                  <h4>{{ item.name }}</h4>
                  <p style="color:#b1b5b9">Adobe</p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagefooter">
        <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :total="total"
          :page-size="30" @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
        </el-pagination>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'course',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        categoryActive: 0,
        tabPosition: '',
        category: [
          {
            id:0,
            name:'全部'
          }
        ],
        id: 1,
        levelArr: [],
        total: 0,
        currentPage: 1,
        listData: []
      }
    },
    mounted() {
      this.getCategory()
      this.getInfo()
      this.allData = this.joinLevel(this.allData)
    },
    methods: {
      getCategory() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/Tool/category', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "limit": 40,
            "page": this.currentPage
          }
        }).then(res => {
          for(let i=0;i<res.data.data.length;i++){
              this.category.push(res.data.data[i])
          }

        }).catch(err => {
          console.log(err)
        })
      },
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/Tool/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "type": "4",
            "category": this.categoryActive,
            "limit": 30,
            "page": this.currentPage
          }
        }).then(res => {
          this.total = res.data.data.total
          this.listData = res.data.data.data
        }).catch(err => {
          console.log(err)
        })
      },
      toDetails(id) {
        this.$router.push({
          path: "/tooldetail",
          query: {
            id: id
          }
        })
      },
      currentChange(e) {
        this.currentPage = e
        this.getInfo()
      },
      prevClick(e) {
        this.currentPage = e
        this.getInfo()
      },
      nextClick(e) {
        this.currentPage = e
        this.getInfo()
      },
      handleClick() {
        this.currentPage = 1
        this.listData = []
        this.getInfo()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pagefooter {
    display: inline-block;
    width: 100%;
    text-align: center;
    margin: 30px 0;
    margin-bottom: 50px;

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #FABE00;
      border: 1px solid #FABE00;
      color: #fff;
    }


    /deep/ .el-pager li {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;

      &:hover {
        color: #3dc57c;
      }
    }

    /deep/ .btn-prev {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      padding: 0 10px;
    }

    /deep/ .btn-next {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      padding: 0 10px;
    }

  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background: none !important;
    border-color: none !important;
    box-shadow: none;
  }


  /deep/ .el-radio-group .is-active {
    margin-left: -1px;
    /* height: 70px; */
    color: black;
    text-align: center;
    box-shadow: 0 2px 2px rgba(84, 48, 132, 0.06);
    /* color: #a9885d; */
    font-size: 15px;
    /* background-image: -webkit-linear-gradient(50deg, #2affda, #b2ff68); */
    /* -webkit-background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    /* background-image: -webkit-linear-gradient(50deg, #2affda, #b2ff68); */
    background-color: #f1f3f7;
    /* font-weight: 900; */
  }

  /deep/ .el-radio-button__inner {
    background: none;
  }

  /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: black;
  }


  /deep/ .el-radio-button {
    padding: 20px;
    border-right: #f1f3f7 1px solid;
    border-top: #f1f3f7 1px solid;
    border-bottom: #f1f3f7 1px solid;
  }

  /deep/ .course .el-radio-group {
    border-left: #f1f3f7 1px solid;
  }

  .course {

    padding: 0px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .course-list {
    width: 1200px;
    margin: -60px auto 0;
  }

  .courseList-filt {
    padding: 30px 0 0px 0;
    margin-top: 8px;
  }

  .part-title {
    font-size: 18px;
    color: #212b34;
    margin-bottom: 28px;
    font-weight: 700;
    text-align: left;
    line-height: 18px;
  }

  .el-form-item__label {
    text-align: center !important;
    font-weight: bold !important;
    line-height: 55px;
  }

  .part-title img {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .card-box {
    font-size: 14px;
    color: #87959f;
    line-height: 20px;
    display: flex;
    flex-wrap: wrap;
    padding-top: 5px;
    width: 1200px;
    margin: 0 auto;
  }

  .card-box .card-li {
    width: 20%;
    margin-bottom: 25px;
    border-radius: 600px;
  }

  .home-course-list {
    width: 94%;
    margin: 10px auto 0;
  }

  .home-course-des {
    color: #000;
    width: 100%;
    background-color: white;
    text-align: left;
    border-radius: 0 0 6px 6px;
  }

  .home-course-des h3 {
    font-size: 16px;
    max-width: 100%;
    height: 40px;
    font-weight: 700;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-left: 15px;
  }

  .authers {
    padding: 6px 4px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-top: 1px solid #F0F0F0;
  }

  .authers h4 {
    height: 40px;
    overflow: inherit;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .authers .tea {
    width: 27px;
    height: 27px;
    border-radius: 100px;
    margin-right: 10px;
  }

  .auther span {
    margin-left: 10px;
    font-size: 12px;
    line-height: 20px;
    color: #525a67;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .home-course-price {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin: 0 15px;
  }

  .price {
    color: #ff5900;
  }

  .home-course-tags {
    color: #b1b5b9;
  }

  .home-course-item {
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    height: 100px;
  }

  .home-course-item img {
    height: 100%;
    width: 100%;
    border-radius: 6px 6px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tool.vue